{
    "welcome-to": "Benvenuto a",
    "copyright": "Copyright",
    "trademarks": "Tutti i marchi o marchi registrati sono proprietà dei rispettivi proprietari.",
    "menu-profile": "Profilo",
    "menu-logout": "Disconnettersi",
    "menu-home": "Home",
    "menu-dashboard": "Cruscotto",
    "menu-machines": "Macchine",
    "menu-colaboration": "Collaborazione",
    "menu-administration": "Amministrazione",
    "menu-machine": "Macchina",
    "menu-list": "Lista",
    "menu-service-data": "Dati di servizio",
    "menu-trash": "Cestino",
    "machine-info": "Informazioni macchina",
    "medium": "Medio",
    "machine-activity": "Attività macchina",
    "machine-part-info": "Informazioni parte della macchina",
    "name": "Nome",
    "version": "Versione",
    "owner": "Proprietario",
    "state": "Stato",
    "actions": "Azioni",
    "kind": "Tipo",
    "description": "Descrizione",
    "size": "Dimensione",
    "last-write": "Ultima modifica",
    "ver": "Ver.",
    "restore": "Ripristina",
    "when": "Quando",
    "type": "Tipo",
    "level": "Livello",
    "text": "Testo",
    "tags": "Tag",
    "part-type": "Tipo di parte",
    "firmware-version": "Versione firmware",
    "model": "Modello",
    "created": "Creato",
    "modified": "Modificato",
    "status": "Stato",
    "loading": "Caricamento",
    "fv": "V.f.",
    "remove": "Rimuovi",
    "user": "Utente",
    "fenix-version": "Versione Fenix",
    "service-data-remove-question": "Sei sicuro di voler eliminare questi dati di servizio?",
    "save-as-duplicate": "Salva come duplicato",
    "upload-file": "Carica file",
    "restore-machine-data-from-backup": "Ripristina dati macchina dal backup",
    "you-want-to-change-owner": "Vuoi cambiare il proprietario?",
    "choose-file": "Scegli file",
    "detail": "Dettaglio",
    "yes": "Sì",
    "no": "No",
    "machine-detail-remove-question": "Sei sicuro di voler eliminare questa macchina?",
    "status-auto-update": "Aggiornamento automatico dello stato",
    "download": "Scarica",
    "copy": "Copia",
    "move": "Sposta",
    "change-owner": "Cambia proprietario",
    "new-machine-name": "Nuovo nome macchina",
    "submit": "Invia",
    "set-as-current": "Imposta come corrente",
    "checkout": "Checkout",
    "base-data": "Dati di base",
    "part-structure-type": "Tipo di struttura della parte",
    "owner-id": "ID proprietario",
    "parent-id": "ID principale",
    "part-class-type": "Tipo di classe della parte",
    "errors": "Errori",
    "generic-device": "Dispositivo generico",
    "device-model": "Modello dispositivo",
    "address": "Indirizzo",
    "camera-info": "Informazioni fotocamera",
    "sensor-model": "Modello sensore",
    "slides-in-view": "Diapositive in vista",
    "slider-info": "Informazioni cursore",
    "channels": "Canali",
    "shot-stats-from": "Statistiche colpi da",
    "shot-stats-to": "Statistiche colpi fino a",
    "shot-stats-counter": "Contatore statistiche colpi",
    "shot-stats": "Statistiche colpi",
    "slider": "Cursore",
    "valve": "Valvola",
    "number-shots": "Numero di colpi",
    "custom": "Personalizzato",
    "move-machine": "Sposta macchina",
    "machine-is-not-selected": "Macchina non selezionata.",
    "machine-successfully-deleted": "Macchina eliminata con successo.",
    "failed-to-delete-machine": "Eliminazione della macchina fallita.",
    "failed-to-backup-machine": "Backup della macchina fallito.",
    "owner-successfully-changed": "Proprietario cambiato con successo.",
    "failed-to-change-owner": "Cambio del proprietario fallito.",
    "machine-successfully-copied": "Macchina copiata con successo.",
    "failed-to-copy-machine": "Copia della macchina fallita.",
    "machine-successfully-moved": "Macchina spostata con successo.",
    "failed-to-move-machine": "Spostamento della macchina fallito.",
    "machine-set-as-current": "Macchina impostata come corrente.",
    "install-app-question": "Vuoi installare l'app 3U Vision Cloud?",
    "install": "Installa",
    "cancel": "Annulla",
    "install-application": "Installa applicazione",
    "step": "Passo",
    "tap-share-icon": "Tocca l'icona di condivisione.",
    "scroll-down-and-tap": "Nel menu di condivisione, scorri verso il basso e tocca",
    "add-to-home-screen": "Aggiungi alla schermata Home",
    "you-will-be-propted": "Ti verrà chiesto di dare un nome all'app. Puoi mantenere il nome predefinito o cambiarlo come desideri. Poi, tocca",
    "add": "Aggiungi",
    "in-top-right-corner": "nell'angolo in alto a destra",
    "do-not-show-again": "Non mostrare più",
    "you-are-offline": "Sei offline.",
    "app-can-not-work-offline": "L'app non può funzionare offline.",
    "please-check-your-internet-connection": "Controlla la tua connessione a Internet.",
    "unexpected-server-version": "Versione del server imprevista.",
    "current-is": "Attuale è",
    "and-expected": "e previsto",
    "application-version-is": "La versione dell'applicazione è",
    "new-version-available": "Nuova versione disponibile",
    "do-you-want-to-install": "Vuoi installarla?",
    "delete-confirmation": "Conferma eliminazione",
    "machine-medium-remove-question": "Sei sicuro di voler eliminare il mezzo?",
    "machine-medium-checkout-error": "Errore nel checkout del mezzo della macchina.",
    "invalid-data": "Dati non validi.",
    "failed-to-load-messages": "Caricamento messaggi fallito.",
    "failed-to-save-board": "Salvataggio della bacheca fallito.",
    "failed-to-delete-board": "Eliminazione della bacheca fallita.",
    "machine-structure-caption": "Struttura",
    "machine-structure-value-caption": "Valore",
    "machine-structure-not-available" : "La struttura della macchina non è disponibile",
    "machines-upload-file-upload-in-progress": "Caricamento del file in corso.",
    "upload-success": "Caricamento riuscito."
  }
